export default "__VITE_ASSET__BeOZEYq0__"